import React, { useRef, useState, useContext, useEffect } from "react";
import axios from "axios";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useUser } from "~/Context/userContext";
import { useSettings } from "~/Context/SettingsContext";
import TrackImage from "./Global/TrackImage";
import Container from "react-bootstrap/Container";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import {
  faPlay,
  faPause,
  faStop,
  faForward,
  faBackward,
  faSpinner,
  faVolumeUp,
  faThList,
  faSearchPlus,
  faSearchMinus,
  faExpandAlt,
  faExpandArrowsAlt as faExpandArrows,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

import { store } from "~/Context/JukeboxContext";
import Duration from "./Duration";
import YouTubePlayer from "react-player/lib/players/YouTube";
import SoundCloud from "react-player/lib/players/SoundCloud";
import MediaSourceIcon from "~/Components/Icons/MediaSourceIcon";

import { isSoundCloudMediaUrl } from "../../utils/media";
import "../../css/Jukebox.less";
// import { genrePlaylists } from "~/utils/genrePlaylists";

library.add(fab);

const JUKEBOX_URL = `https://www.dreamchimney.com/tracks/jukebox/playlists`;
const JUKEBOX_LEGACY_URL = `//www.dreamchimney.com/tracks/api.php`;

// get all the playlists
// http://www.dreamchimney.com/tracks/api.php?route=totd_playlists&chim=ryan

// http://www.dreamchimney.com/tracks/jukebox/playlists/most-recent.json?v=1577835637559

// get a single track (includes last 20)
// http://www.dreamchimney.com/tracks/api.php?route=single_track&track_id=41214&1578031837761

function Jukebox() {
  const thePlayer = useRef(null);
  const { settings } = useSettings();
  const { state: userState } = useUser();

  const [loading, setLoading] = useState(true);
  const [duration, setDuration] = useState(0);
  const [playlist, setPlaylist] = useState({ name: "", tracks: [] });
  const [playing, setPlaying] = useState(false);
  const [paused, setPaused] = useState(false);
  const [played, setPlayed] = useState(0);
  const [volume, setVolume] = useState(1);
  const [currentTrack, setCurrentTrack] = useState({});
  const [videoExpand, setVideoExpand] = useState(false);

  const globalState = useContext(store);
  const { dispatch } = globalState;

  const cacheBuster = new Date().getTime();

  const longText = (text, max) => {
    if (text && text.length > max) {
      return text.substr(0, max) + "...";
    }
    return text;
  };

  /**
   * load most recent tracks
   * @param {*} playing auto starts the playlist
   */
  const getPlaylistMostRecent = async (playing = false) => {
    setLoading(true);
    await axios.get(`${JUKEBOX_URL}/most-recent.json?v=${cacheBuster}`).then(({ data }) => {
      // if ryan, filter out spider tracks
      let playlist = data[0];
      if (isLoggedin() && userState.user && userState.user.dir === "ryan") {
        const tracks = playlist.tracks.filter((p) => p.chimdir !== "spider");
        playlist = { ...playlist, tracks };
      }
      setPlaylist(playlist); // shape of response is odd. its an array with object
      dispatch({ type: "load_playlist", playlist: playlist, playing });
      setLoading(false);
    });
  };

  /**
   * load favorites playlist
   * @param {*} playing auto starts the playlist
   */
  const getPlaylistFavorites = async (playing = false) => {
    setLoading(true);
    await axios.get(`${JUKEBOX_URL}/favorites_${userState.user.dir}.json?v=${cacheBuster}`).then(({ data }) => {
      setPlaylist(data[0]); // shape of response is odd. its an array with object
      dispatch({ type: "load_playlist", playlist: data[0], playing });
      setLoading(false);
    });
  };
  /**
   * load radio as a playlist
   * @param {*} playing auto starts the playlist
   */
  const getPlaylistRadio = (playing = false) => {
    setLoading(true);

    // fake radio playlist
    const radioPlaylist = {
      tracks: [
        {
          id: "0",
          date: "02.27.2021",
          title: "Radio",
          artist: "Radio",
          chimdir: "ryan",
          sc_url: "",
          genre_id: "610",
          genre: "Baked Electronics",
          media_type: "radio",
          media_id: "",
        },
      ],
    };

    dispatch({ type: "load_playlist", playlist: radioPlaylist, playing });
    setPlaylist(radioPlaylist); // shape of response is odd. its an array with object
    setTimeout(() => {
      setLoading(false);
    }, 4000);
  };

  /**
   * load favorites playlist
   * @param {*} playing auto starts the playlist
   */
  const getPlaylistUserMostRecent = async (playing = false) => {
    setLoading(true);
    const { data } = await axios.get(`${JUKEBOX_URL}/most-recent_${userState.user.dir}.json?v=${cacheBuster}`);
    setPlaylist(data[0]); // shape of response is odd. its an array with object
    dispatch({ type: "load_playlist", playlist: data[0], playing });
    setLoading(false);
  };
  /**
   * load genre playlist
   * @param {*} playing auto starts the playlist, 183
   */
  const getPlaylistGenre = async (genreId, playing = false) => {
    setLoading(true);
    const { data } = await axios.get(`${JUKEBOX_LEGACY_URL}?route=genre_playlist&genre_id=${genreId}`);
    setPlaylist(data[0]); // shape of response is odd. its an array with object
    dispatch({ type: "load_playlist", playlist: data[0], playing });
    setLoading(false);
  };

  // youtube track was stopping at like 0.997123123121332 instead of 1
  const roundPlayedCounter = (state) => Math.round(state.played * 1000) / 1000;

  const trackCompleted = (state) => roundPlayedCounter(state) >= 0.99 || (playing && state.played === 0 && state.loaded > 0);

  useEffect(() => {
    if (userState.loaded) {
      getPlaylistMostRecent();
    }
  }, [userState.loaded]);

  const getCurrentTrack = (state) => {
    if (state.playing === true && Object.keys(state.currentTrack).length === 0) {
      const position = state.position || 0;
      return (state.tracks && state.tracks[position]) || {};
    }
    return state.currentTrack;
  };

  const handleChangePlaylist = (event) => {
    if (event.target.value === "radio") {
      getPlaylistRadio(true);
    }
    if (event.target.value === "favorites") {
      getPlaylistFavorites(true);
    }
    if (event.target.value === "most_recent") {
      getPlaylistMostRecent(true);
    }
    if (event.target.value === "user_most_recent") {
      getPlaylistUserMostRecent(true);
    }
    if (event.target.value.startsWith("genre-")) {
      const genreId = event.target.value.replace(/genre-/gi, "");
      getPlaylistGenre(genreId, true);
    }
  };

  const playRadio = () => {
    getPlaylistRadio(true);
    setPlayed(1); // triggers the eq gif
  };

  useEffect(() => {
    setPlaying(globalState.state.playing);
    setPaused(globalState.state.paused);
    setCurrentTrack(getCurrentTrack(globalState.state));
    setPlaylist({ name: globalState.state.name, tracks: globalState.state.tracks });
    if (globalState.state.seeking) {
      handleSeek(globalState.state.seekTo);
      dispatch({ type: "track_seek_complete" });
    }
  }, [globalState]);

  const playerToggle = () => {
    dispatch({ type: "toggle" });
  };

  const playerStop = () => {
    dispatch({ type: "stop" });
  };
  const playerForward = () => {
    dispatch({ type: "forward" });
  };
  const playerReverse = () => {
    dispatch({ type: "rewind" });
  };
  const handleSeek = (s) => {
    thePlayer.current.seekTo(s);
  };

  const handleProgress = (state) => {
    let progressPercent = 0;
    if (state.played > 0) {
      progressPercent = Math.round(100 - (1 - state.played) * 100);
    }
    //if (progressPercent % 2 === 0) {
    dispatch({ type: "track_progress", progress: progressPercent });
    //}

    setPlayed(state.played);

    // sometimes .played finishes at 0, sometime at 1. this covers both cases
    // if (state.played >= 1 || (playing && state.played === 0 && state.loaded > 0)) {
    // if user wants a custom playlist its safe to assume the player should continue forward after each track
    if (trackCompleted(state)) {
      settings.autoplayInJukebox || playlist.name == "Custom Playlist" ? playerForward() : playerStop();
    }
  };

  const handleDuration = (duration) => {
    setDuration(duration);
  };

  const handleError = () => {
    playerForward();
  };

  const isLoggedin = () => userState && userState.loggedin;
  const isLoggedinChim = () => userState && userState.loggedin && userState.isChim;

  const isRadio = currentTrack.media_type === "radio";

  // not ready, pause button goes into infinity loop
  // window.addEventListener("keydown", function (e) {
  //   if (e.keyCode === 32 && e.target == document.body) {
  //     e.preventDefault();
  //     if (playing) {
  //       console.log("Pause");
  //       playerToggle();
  //     }
  //   }
  // });

  return (
    <div>
      <div className="jukeboxTab">Dream Chimney: Jukebox</div>
      <footer>
        <Container className="" id="totd-jukebox">
          <Row className="jukebox-inner">
            {playing && currentTrack.sc_url && currentTrack.media_type !== "radio" && !isSoundCloudMediaUrl(currentTrack) && (
              <FontAwesomeIcon
                onClick={() => setVideoExpand(!videoExpand)}
                icon={videoExpand ? faSearchMinus : faSearchPlus}
                style={{ position: "absolute", top: 5, left: 5 }}
              />
            )}
            <Col xs={12} sm={8} className="col-left-side">
              <div className="totd-player">
                <div className="totd-player-inner">
                  <Col xs={5} sm={8} md={5} className="totd-player-controls col-left">
                    <button onClick={() => playerToggle()} disabled={loading}>
                      {playing ? <FontAwesomeIcon icon={faPause} /> : <FontAwesomeIcon icon={faPlay} />}
                    </button>
                    <button onClick={() => playerStop()}>
                      <FontAwesomeIcon icon={faStop} />
                    </button>
                    <button onClick={() => playerReverse()} disabled={isRadio}>
                      <FontAwesomeIcon icon={faBackward} />
                    </button>
                    <button onClick={() => playerForward()} disabled={isRadio}>
                      <FontAwesomeIcon icon={faForward} />
                    </button>

                    <div>
                      <div style={{ marginTop: "5px" }}>
                        <FontAwesomeIcon icon={faVolumeUp} />
                        <input
                          type="range"
                          min="0"
                          max="1"
                          step="any"
                          value={volume}
                          onChange={(e) => setVolume(parseFloat(e.target.value))}
                        />
                      </div>
                    </div>
                  </Col>

                  <Col xs={7} sm={10} md={7} className="now-playing col-middle">
                    {playing && (
                      <div>
                        {isRadio ? (
                          <span className="now-playing-thumbnail">
                            <a
                              totd-track-event="DCJukeboxRadio"
                              href="//www.dreamchimney.com/radio"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img alt="Currently Playing" src={`//www.dreamchimney.com/tracks/track_images/dc_radio_logo_sm.jpg`} />
                            </a>
                          </span>
                        ) : (
                          <Link to={`/${currentTrack.id}`} className="now-playing-thumbnail">
                            <TrackImage track={currentTrack} alt="Currently Playing" link={false} width={null} />
                          </Link>
                        )}

                        <span className="now-playing-heading">
                          {loading && (
                            <span className="loading">
                              <FontAwesomeIcon icon={faSpinner} spin />
                              <span className="sr-only">Loading...</span>
                            </span>
                          )}
                          <p className="now-playing-track">
                            <span style={{ marginRight: "5px" }}>
                              <MediaSourceIcon track={currentTrack} />
                            </span>
                            {currentTrack.media_type !== "radio" && (
                              <React.Fragment>
                                "<Link to={`/${currentTrack.id}`}>{longText(currentTrack.title, 40)}</Link>" by{" "}
                                {longText(currentTrack.artist, 30)}
                              </React.Fragment>
                            )}
                            {isRadio &&
                              (loading ? (
                                <div>Loading, please hold...</div>
                              ) : (
                                <div>
                                  You are listening to...
                                  <br />
                                  Dream Chimney Radio
                                </div>
                              ))}
                          </p>
                          {!isRadio && (
                            <div className="time">
                              (<Duration seconds={duration * played} /> / <Duration seconds={duration} />)
                            </div>
                          )}
                        </span>
                      </div>
                    )}
                  </Col>
                </div>
              </div>
            </Col>
            <Col xs={0} sm={0} md={4} className="col-right">
              <div className="form-group">
                <div>
                  <FontAwesomeIcon icon={faThList} /> <i className="fa fa-list" aria-hidden="true"></i> Playlist:
                  <select className="playlistSelect" onChange={handleChangePlaylist}>
                    <option selected>
                      {playlist.name} ({playlist.tracks && playlist.tracks.length} tracks)
                    </option>
                    <option disabled>-----</option>
                    {/* <option value="radio">Dream Chimney Radio</option> */}
                    <option value="most_recent">Most Recent Tracks</option>
                    {isLoggedinChim() && (
                      <>
                        <option value="favorites">Your Favorites</option>
                      </>
                    )}
                    {isLoggedinChim() && (
                      <>
                        <option value="user_most_recent">Your Most Recent Tracks</option>
                      </>
                    )}
                    {/* <option disabled>-----</option>
                    {genrePlaylists.map((genre) => (
                      <option key={genre.id} value={genre.id}>
                        {genre.name}
                      </option>
                    ))} */}
                  </select>
                  {/* ({playlist.tracks && playlist.tracks.length} tracks) */}
                </div>
                {playing && played > 0 && (
                  <div className="eq">
                    <img src="//www.dreamchimney.com/tracks/jukebox/eq.gif" alt="Track is playing" />
                  </div>
                )}
              </div>
              {!playing && (
                <div onClick={() => playRadio()} className="playRadioButton">
                  <FontAwesomeIcon icon={faPlay} /> Play Dream Chimney Radio
                </div>
              )}
            </Col>
          </Row>
          <div className="jukebox-outer" className="{'isChrome': isChrome, 'isYouTubePlaying': isYouTubePlaying}">
            <div id="jukebox-video-wrapper"></div>
          </div>
        </Container>
      </footer>

      {currentTrack.media_type === "radio" && (
        <div style={{ display: "none" }}>
          <audio autoplay="autoplay" controls>
            <source src="https://www.radioking.com/play/dream-chimney-radio" type="audio/mpeg" />
          </audio>
        </div>
      )}

      {currentTrack.sc_url && currentTrack.media_type !== "radio" && isSoundCloudMediaUrl(currentTrack) ? (
        <SoundCloud
          id="player"
          ref={thePlayer}
          volume={volume}
          className={"player-hide"}
          url={currentTrack.sc_url}
          playing={playing}
          onProgress={handleProgress}
          onDuration={handleDuration}
          onError={handleError}
        />
      ) : (
        <YouTubePlayer
          ref={thePlayer}
          id="player"
          volume={volume}
          className={!playing && !paused ? "player-hide" : videoExpand ? "player-show-max" : ""}
          url={currentTrack.sc_url}
          playing={playing}
          onProgress={handleProgress}
          onDuration={handleDuration}
          onError={handleError}
        />
      )}
    </div>
  );
}

export default Jukebox;
